
import React from "react";
import { Typography } from "@mui/material";
import './Stylesheet.css';

const TypographyD = ({
  align,
  color,
  label,
  variant,
  fontweight,
  fontSize,
  marginBottom,
  marginTop,
  onClick,
  style = {}, // Accept custom styles
}) => {
  return (
    <Typography
      variant={variant}
      fontWeight={fontweight}
      gutterBottom
      textAlign={align}
      onClick={onClick}
      style={{
        marginBottom,
        marginTop,
        letterSpacing: ".5px",
        color,
        fontSize,
        ...style, // Merge custom styles last to override
      }}
    >
      {label}
    </Typography>
  );
};

export default TypographyD;
